<template>
  <ul class="dx-list">
    <slot></slot>
  </ul>
</template>
<script>
export default {
  name: 'dx-list',
};
</script>
<style scoped lang="scss">
.dx-list {
  list-style-type: none;
}
</style>
